/**
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { mainChannel } from "../../../../../init/message-hub";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  className: "cookie-setting",

  detailsVisible: false,

  events: {
    "click .collapse-details": "collapseDetails",
    "click .cookie-checkbox": "toggleCookie"
  },

  initialize(cookie, immutable) {
    this.render();
    this.initElements();
    this.initCookie(cookie, immutable);
  },

  render() {
    this.$el.html(template);
  },

  initCookie(cookie, immutable) {
    this.cookie = cookie;
    this.$companyName.html(
      `<span class="collapse-details">&#9654;</span>${cookie.name}`
    );
    this.$companyDomains.html(cookie.domains.toString().replace(/,/g, ", "));
    this.$details.html(
      `${cookie.description}<br><a href="${
        cookie.terms
      }">Terms & Conditions</a><br><a href="${
        cookie.privacy
      }">Privacy Policy</a>`
    );
    if (immutable) {
      this.$localSwitcher.prop("disabled", true);
      this.$localSwitcher
        .parent()
        .find(".slider")
        .addClass("disabled");
    }
  },

  initElements() {
    this.$companyName = $(this.$(".company-name"));
    this.$companyDomains = $(this.$(".company-domains"));
    this.$details = $(this.$(".details-row"));
    this.$localSwitcher = $(this.$(".cookie-checkbox"));
  },

  collapseDetails() {
    if (!this.detailsVisible) {
      this.$details.show();
      this.$(".collapse-details").html("&#9660;");
    } else {
      this.$details.hide();
      this.$(".collapse-details").html("&#9654;");
    }
    this.detailsVisible = !this.detailsVisible;
  },

  toggleCookie(e) {
    const checked = $(e.target).is(":checked");
    mainChannel.request("toggleCookie", this.cookie, checked);
  },

  reset() {
    this.$localSwitcher.prop("checked", this.cookie.accepted);
    this.delegateEvents();
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/pages/details/partials/cookie-setting/cookie-setting.js